import * as React from 'react';
import { useGetShipmentHistoryQuery } from "../../../apis/ShipmentHistory.api";
import { PrimaryShipmentHistory, ShipmentHistory } from "../../../types/models/ShipmentHistory";
import ShipmentName from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ShipmentHistory;
};

export const ShipmentHistoryNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><ShipmentName id={ data?.shipmentId }/>
                    {data?.action && <> | </> }{ data?.action }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ShipmentHistoryName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetShipmentHistoryQuery(PrimaryShipmentHistory.fromId(id))
    return (<ShipmentHistoryNameDisplay data={data}/>)
}

export default ShipmentHistoryName;
